module.exports = __webpack_public_path__ + "static/2nd-tpm-1-7108af0b509336565572b31fa64df4f7.jpg";